import React, {Dispatch, SetStateAction} from "react";
import Button from "@awsui/components-react/button";
import {useMutation} from "react-query";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import {useAuth} from "hooks/useAuth";
import User from "model/User";
import removePenalty from "api/removePenalty";


interface RemovePenaltyButtonProps {
    userToPenalty: User;
    competitionCode: string;
    leagueId: number;
    setSubmitMessage: Dispatch<SetStateAction<FlashbarProps.MessageDefinition | undefined>>;
}

const RemovePenaltyButton: React.FC<RemovePenaltyButtonProps> = (props) => {

    const [{user}] = useAuth();
    const {userToPenalty, competitionCode, leagueId} = props;

    const {
        mutate: callRemovePenalty,
        isLoading: setRemovePenaltyIsLoading
    } = useMutation((penaltyUser: User) => removePenalty(penaltyUser, competitionCode, leagueId, user?.token), {
        onSuccess: () => {
            props.setSubmitMessage({
                header: "Penalty removed correctly",
                type: "success",
                content: "",
            })
        },
        onError: () => {
            props.setSubmitMessage({
                header: "Error when removing penalty",
                type: "error",
                content: "Try to refresh the page.",
            })
        }
    });

    return (
        <Button
            iconAlign="left"
            loading={setRemovePenaltyIsLoading}
            variant="normal"
            onClick={() => callRemovePenalty(userToPenalty)}
        >
            Submit
        </Button>
    );
};

export default RemovePenaltyButton;